import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Button } from '@components/Button';
import { themeColor, themeMediaQuery } from '@utils/styledTheme.util';
import Modal from 'react-modal';

export const StyledModal = styled(Modal)`
  display: flex;
  min-height: 600px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const ModalWrapper = styled(Flex)`
  background-color: ${themeColor('black')};
  height: 100vh;
  width: 100vw;
  padding: 0px;
`;

export const ModalBody = styled(Flex)`
  height: inherit;
  min-height: 600px;
`;

export const VideoContainer = styled(Box)`
  height: 58vw;
  width: 100vw;
  @media screen and (min-width: 30em) {
    height: 56.25vw;
    width: 93vw;
  }
  ${themeMediaQuery('sm')} {
    height: 56.25vw;
    width: 93vw;
  }
  ${themeMediaQuery('lg')} {
    height: 47vw;
    width: 80vw;
  }
`;

export const StyledCloseButton = styled(Button)`
  top: 0;
  width: 65px;
  border: none;
  position: absolute;
  :focus {
    outline: none;
  }
  &:hover {
    background: transparent;
  }
`;
